/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-fa22eda7.mjs';
import { defineComponent, createVNode, mergeProps, computed } from 'vue';
import { UploadIcon } from 'tdesign-icons-vue-next';
import props from './props.mjs';
import NormalFile from './themes/normal-file.mjs';
import DraggerFile from './themes/dragger-file.mjs';
import ImageCard from './themes/image-card.mjs';
import MultipleFlowList from './themes/multiple-flow-list.mjs';
import useUpload from './hooks/useUpload.mjs';
import { Button } from '../button/index.mjs';
import CustomFile from './themes/custom-file.mjs';
import { useContent, useTNodeJSX } from '../hooks/tnode.mjs';
import { useFormDisabled } from '../form/hooks.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-be6b014c.mjs';
import '../_chunks/dep-558fadc3.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../_chunks/dep-1ec078b3.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-b9505f3d.mjs';
import '../_chunks/dep-b390ff23.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-51567b45.mjs';
import '../_chunks/dep-9a7888c7.mjs';
import '../_chunks/dep-af8c0169.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-4371fb57.mjs';
import '../_chunks/dep-31d34e52.mjs';
import '../_chunks/dep-67e8723b.mjs';
import '../_chunks/dep-0bf03d55.mjs';
import '../_chunks/dep-5b5daf08.mjs';
import '../_chunks/dep-95049222.mjs';
import '../_chunks/dep-ac19a2b6.mjs';
import '../_chunks/dep-90d97bcb.mjs';
import '../_chunks/dep-c8679a16.mjs';
import '../_chunks/dep-939a74d6.mjs';
import '../_chunks/dep-e4f65bc4.mjs';
import '../_chunks/dep-45572c49.mjs';
import '../_chunks/dep-1aa18f5f.mjs';
import '../_chunks/dep-e09a06d8.mjs';
import '../_chunks/dep-07f3660d.mjs';
import '../_chunks/dep-0d3220b0.mjs';
import '../_chunks/dep-895678a0.mjs';
import '../_chunks/dep-b2bdc7b9.mjs';
import '../_chunks/dep-0f45a6e0.mjs';
import '../_chunks/dep-35a4fd8d.mjs';
import '../_chunks/dep-54378e60.mjs';
import '../_chunks/dep-25b8bf4b.mjs';
import '../_chunks/dep-c40264c0.mjs';
import '../_chunks/dep-9d499243.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-0927ceb7.mjs';
import '../_chunks/dep-f0bd05df.mjs';
import '../config-provider/type.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-55311368.mjs';
import '../_chunks/dep-c25d13e7.mjs';
import '../_chunks/dep-2a69909d.mjs';
import '../_chunks/dep-c24f5c5d.mjs';
import '../_chunks/dep-79d42d5d.mjs';
import '../_chunks/dep-979d7716.mjs';
import '../_chunks/dep-8b3be089.mjs';
import '../_chunks/dep-84053b94.mjs';
import '../_chunks/dep-398227bb.mjs';
import '../loading/props.mjs';
import '../hooks/useTeleport.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../loading/type.mjs';
import '../link/index.mjs';
import '../link/link.mjs';
import '../link/props.mjs';
import '../link/type.mjs';
import '../_common/js/upload/utils.mjs';
import '../_common/js/log/log.mjs';
import '../hooks/useGlobalIcon.mjs';
import './constants.mjs';
import '../hooks/useCommonClassName.mjs';
import './hooks/useDrag.mjs';
import '../image-viewer/index.mjs';
import '../image-viewer/image-viewer.mjs';
import '../image-viewer/props.mjs';
import '../image-viewer/base/ImageModalIcon.mjs';
import '../image-viewer/base/ImageViewerUtils.mjs';
import '../tooltip/index.mjs';
import '../tooltip/tooltip.mjs';
import '../_chunks/dep-ad4331e8.mjs';
import '../_chunks/dep-16b9f817.mjs';
import '../_chunks/dep-e40749a5.mjs';
import '../_chunks/dep-437754aa.mjs';
import '../_chunks/dep-6dbd6c24.mjs';
import '../tooltip/props.mjs';
import '../popup/props.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../_chunks/dep-a861ee00.mjs';
import '../_chunks/dep-3514a375.mjs';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../hooks/useVModel.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../popup/container.mjs';
import '../hooks/useResizeObserver.mjs';
import '../popup/type.mjs';
import '../tooltip/util.mjs';
import '../tooltip/type.mjs';
import '../image-viewer/utils.mjs';
import '../image-viewer/base/ImageItem.mjs';
import '../image-viewer/hooks.mjs';
import '../image-viewer/base/ImageViewerModal.mjs';
import '../dialog/index.mjs';
import '../dialog/dialog.mjs';
import '../dialog/props.mjs';
import '../dialog/hooks.mjs';
import '../dialog/stack.mjs';
import '../_common/js/utils/getScrollbarWidth.mjs';
import '../button/button.mjs';
import '../button/props.mjs';
import '../hooks/useDisabled.mjs';
import '../_chunks/dep-44e322cb.mjs';
import '../button/type.mjs';
import '../dialog/type.mjs';
import '../dialog/plugin.mjs';
import '../image-viewer/const.mjs';
import '../image/index.mjs';
import '../image/image.mjs';
import '../_common/js/utils/observe.mjs';
import '../image/props.mjs';
import '../space/index.mjs';
import '../space/space.mjs';
import '../space/props.mjs';
import '../space/type.mjs';
import '../image/type.mjs';
import '../image-viewer/type.mjs';
import '../_common/js/upload/main.mjs';
import '../_chunks/dep-dbbdd44f.mjs';
import '../_common/js/upload/xhr.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _Upload = defineComponent({
  name: "TUpload",
  props: props,
  setup: function setup(props2, _ref) {
    var slots = _ref.slots,
      expose = _ref.expose;
    var renderContent = useContent();
    var renderTNodeJSX = useTNodeJSX();
    var _useUpload = useUpload(props2),
      locale = _useUpload.locale,
      classPrefix = _useUpload.classPrefix,
      triggerUploadText = _useUpload.triggerUploadText,
      toUploadFiles = _useUpload.toUploadFiles,
      displayFiles = _useUpload.displayFiles,
      uploadValue = _useUpload.uploadValue,
      sizeOverLimitMessage = _useUpload.sizeOverLimitMessage,
      uploading = _useUpload.uploading,
      tipsClasses = _useUpload.tipsClasses,
      errorClasses = _useUpload.errorClasses,
      placeholderClass = _useUpload.placeholderClass,
      inputRef = _useUpload.inputRef,
      onInnerRemove = _useUpload.onInnerRemove,
      uploadFiles = _useUpload.uploadFiles,
      onNormalFileChange = _useUpload.onNormalFileChange,
      onDragFileChange = _useUpload.onDragFileChange,
      onPasteFileChange = _useUpload.onPasteFileChange,
      triggerUpload = _useUpload.triggerUpload,
      cancelUpload = _useUpload.cancelUpload,
      uploadFilePercent = _useUpload.uploadFilePercent;
    var disabled = useFormDisabled();
    expose({
      upload: inputRef.value,
      uploading: uploading,
      triggerUpload: triggerUpload,
      uploadFiles: uploadFiles,
      cancelUpload: cancelUpload,
      uploadFilePercent: uploadFilePercent
    });
    var renderTrigger = function renderTrigger() {
      var getDefaultTrigger = function getDefaultTrigger() {
        if (props2.theme === "file-input") {
          return createVNode(Button, mergeProps({
            "disabled": disabled.value,
            "variant": "outline"
          }, props2.triggerButtonProps), {
            "default": function _default() {
              return [triggerUploadText.value];
            }
          });
        }
        return createVNode(Button, mergeProps({
          "disabled": disabled.value,
          "variant": "outline",
          "icon": function icon() {
            return createVNode(UploadIcon, null, null);
          }
        }, props2.triggerButtonProps), {
          "default": function _default() {
            return [triggerUploadText.value];
          }
        });
      };
      return renderContent("default", "trigger", {
        params: {
          dragActive: false,
          files: uploadValue.value
        }
      }) || getDefaultTrigger();
    };
    var commonDisplayFileProps = computed(function () {
      return {
        accept: props2.accept,
        files: uploadValue.value,
        toUploadFiles: toUploadFiles.value,
        displayFiles: displayFiles.value,
        theme: props2.theme,
        placeholder: props2.placeholder,
        disabled: disabled.value,
        tips: props2.tips,
        status: props2.status,
        sizeOverLimitMessage: sizeOverLimitMessage.value,
        uploading: uploading.value,
        classPrefix: classPrefix.value,
        tipsClasses: tipsClasses,
        errorClasses: errorClasses,
        placeholderClass: placeholderClass,
        locale: locale.value,
        autoUpload: props2.autoUpload,
        abridgeName: props2.abridgeName,
        showUploadProgress: props2.showUploadProgress,
        fileListDisplay: props2.fileListDisplay,
        onRemove: onInnerRemove,
        uploadPastedFiles: props2.uploadPastedFiles,
        onPasteFileChange: onPasteFileChange
      };
    });
    var dragProps = {
      onDragFileChange: onDragFileChange,
      onDragenter: props2.onDragenter,
      onDragleave: props2.onDragleave,
      onDrop: props2.onDrop
    };
    var getNormalFileNode = function getNormalFileNode() {
      return createVNode(NormalFile, mergeProps(commonDisplayFileProps.value, {
        "multiple": props2.multiple
      }), {
        "default": function _default() {
          return [createVNode("div", {
            "class": "".concat(classPrefix.value, "-upload__trigger"),
            "onClick": triggerUpload
          }, [renderTrigger()])];
        },
        fileListDisplay: slots.fileListDisplay,
        "file-list-display": slots["file-list-display"]
      });
    };
    var getSingleFileDraggerUploadNode = function getSingleFileDraggerUploadNode() {
      return createVNode(DraggerFile, mergeProps(commonDisplayFileProps.value, {
        "dragEvents": dragProps,
        "trigger": props2.trigger,
        "cancelUpload": cancelUpload,
        "triggerUpload": triggerUpload,
        "uploadFiles": uploadFiles,
        "onCancelUpload": props2.onCancelUpload
      }), {
        fileListDisplay: slots.fileListDisplay,
        "file-list-display": slots["file-list-display"]
      });
    };
    var getImageCardUploadNode = function getImageCardUploadNode() {
      return createVNode(ImageCard, mergeProps(commonDisplayFileProps.value, {
        "multiple": props2.multiple,
        "max": props2.max,
        "showUploadProgress": props2.showUploadProgress,
        "triggerUpload": triggerUpload,
        "uploadFiles": uploadFiles,
        "cancelUpload": cancelUpload,
        "onPreview": props2.onPreview
      }), {
        fileListDisplay: slots.fileListDisplay,
        "file-list-display": slots["file-list-display"]
      });
    };
    var getFlowListNode = function getFlowListNode() {
      return createVNode(MultipleFlowList, mergeProps(commonDisplayFileProps.value, {
        "isBatchUpload": props2.isBatchUpload,
        "draggable": props2.draggable,
        "dragEvents": dragProps,
        "uploadFiles": uploadFiles,
        "cancelUpload": cancelUpload,
        "onPreview": props2.onPreview,
        "showThumbnail": props2.showThumbnail
      }), {
        "default": function _default() {
          return [createVNode("div", {
            "class": "".concat(classPrefix.value, "-upload__trigger"),
            "onClick": triggerUpload
          }, [!props2.draggable && renderTrigger()])];
        },
        fileListDisplay: slots.fileListDisplay,
        "file-list-display": slots["file-list-display"]
      });
    };
    var getCustomFile = function getCustomFile() {
      return createVNode(CustomFile, mergeProps(commonDisplayFileProps.value, {
        "draggable": props2.draggable,
        "dragContent": props2.dragContent,
        "dragEvents": dragProps,
        "triggerUpload": triggerUpload,
        "trigger": props2.trigger,
        "childrenNode": slots["default"]
      }), {
        "default": function _default() {
          return [renderTrigger()];
        },
        dragContent: slots.dragContent,
        "drag-content": slots["drag-content"],
        trigger: slots.trigger
      });
    };
    return function () {
      return createVNode("div", {
        "class": "".concat(classPrefix.value, "-upload"),
        "onPaste": props2.uploadPastedFiles && onPasteFileChange
      }, [createVNode("input", mergeProps({
        "ref": inputRef,
        "type": "file",
        "disabled": disabled.value,
        "onChange": onNormalFileChange,
        "multiple": props2.multiple,
        "accept": props2.accept,
        "hidden": true
      }, props2.inputAttributes ? _objectSpread({}, props2.inputAttributes) : {}), null), ["file", "file-input"].includes(props2.theme) && !props2.draggable && getNormalFileNode(), ["file", "image"].includes(props2.theme) && props2.draggable && getSingleFileDraggerUploadNode(), props2.theme === "image" && !props2.draggable && getImageCardUploadNode(), ["image-flow", "file-flow"].includes(props2.theme) && getFlowListNode(), props2.theme === "custom" && getCustomFile(), Boolean(props2.tips || slots.tips) && createVNode("small", {
        "class": [tipsClasses, _defineProperty({}, "".concat(classPrefix.value, "-upload__tips-").concat(props2.status), props2.status)]
      }, [renderTNodeJSX("tips")])]);
    };
  }
});

export { _Upload as default };
//# sourceMappingURL=upload.mjs.map
